export default __webpack_public_path__ + "static/media/login-dashboard.32c393c7.png";